import { FormGroup, Checkbox } from "@blueprintjs/core";
import {
  EnumCheckboxProps,
  EnumCheckboxFieldValue,
  FieldLabeledProps,
} from "../../types/fieldTypes";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { useEnumCheckboxField } from "./useEnumCheckboxField";

/** Base EnumCheckboxField Props*/
export interface EnumCheckboxFieldProps extends EnumCheckboxProps {
  labelProps?: FieldLabeledProps;
  showSelectAll?: boolean;
}

const EnumCheckboxField: React.FC<EnumCheckboxFieldProps> = (props) => {
  const { localValues, setLocalValues } = useEnumCheckboxField(props);

  return (
    <div className="ucl-base-input-checkbox-field-container">
      <FormGroup
        className={`${
          props.isRequired && (!localValues || localValues?.length === 0)
            ? "has-required-background"
            : "base-field"
        }`}
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValues }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        {props.showSelectAll && (
          <Checkbox
            name="Select All"
            label="Select All"
            disabled={props.disabled}
            checked={localValues?.length === (props.optionValues || []).length}
            onChange={(e) => {
              if (e.target.checked) {
                const newLocalValues = (props.optionValues || []).map(
                  (option) => option.value
                );
                setLocalValues(newLocalValues);
                props.onSubmit?.(newLocalValues);
              } else {
                setLocalValues([]);
                props.onSubmit?.([]);
              }
            }}
          />
        )}
        {(props.optionValues || [])
          .filter((option) => !!option.value)
          .map((option, idx) => {
            const checked = localValues?.some((arg) => arg === option.value);
            return (
              <Checkbox
                key={idx}
                name={option.label}
                label={option.label}
                disabled={props.disabled}
                checked={checked}
                onChange={() => {
                  let newLocalValues: EnumCheckboxFieldValue;
                  if (checked) {
                    const filteredValues = localValues?.filter(
                      (localValue) => localValue !== option.value
                    );
                    newLocalValues =
                      filteredValues && filteredValues.length > 0
                        ? filteredValues
                        : [];
                  } else {
                    newLocalValues = localValues
                      ? [...localValues, option.value]
                      : [option.value];
                  }
                  setLocalValues(newLocalValues);
                  props.onSubmit && props.onSubmit(newLocalValues);
                }}
              />
            );
          })}
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default EnumCheckboxField;
